// Categorías y divisiones estándar RFFM para scouting de jugadores rivales.
export const RIVAL_CATEGORIES = {
  "Aficionados": ["Tercera RFEF", "Autonómica", "Preferente", "Primera", "Segunda"],
  "Juvenil": ["División de Honor", "Liga Nacional", "Autonómica", "Preferente", "Primera", "Segunda"],
  "Cadete": ["Superliga", "División de Honor", "Autonómica", "Preferente", "Primera", "Segunda"],
  "Infantil": ["Superliga", "División de Honor", "Autonómica", "Preferente", "Primera", "Segunda"],
  "Alevín": ["División de Honor", "Autonómica", "Preferente", "Primera", "Segunda"],
  "Benjamín": ["División de Honor", "Autonómica", "Preferente", "Primera", "Segunda"],
};

export const RIVAL_DECISIONS = [
  { value: "fichar", label: "Fichar", cls: "bg-emerald-100 text-emerald-700 border-emerald-300" },
  { value: "seguir_observando", label: "Seguir observando", cls: "bg-amber-100 text-amber-700 border-amber-300" },
  { value: "descartar", label: "Descartar", cls: "bg-rose-100 text-rose-700 border-rose-300" },
];

export const RIVAL_EVAL_AREAS = [
  { key: "tecnicos", label: "Aspectos técnicos" },
  { key: "tacticos", label: "Aspectos tácticos" },
  { key: "fisicos", label: "Aspectos físicos" },
  { key: "emocional", label: "Aspecto emocional" },
];

export const RIVAL_SCALE = [
  { value: 4, label: "Excelente", cls: "bg-emerald-100 text-emerald-700 border-emerald-300 ring-emerald-500" },
  { value: 3, label: "Adecuado", cls: "bg-blue-100 text-blue-700 border-blue-300 ring-blue-500" },
  { value: 2, label: "En desarrollo", cls: "bg-amber-100 text-amber-700 border-amber-300 ring-amber-500" },
  { value: 1, label: "Necesita mejorar", cls: "bg-rose-100 text-rose-700 border-rose-300 ring-rose-500" },
];

export const blankRivalEvaluation = () => ({
  tecnicos: { score: null, comment: "" },
  tacticos: { score: null, comment: "" },
  fisicos: { score: null, comment: "" },
  emocional: { score: null, comment: "" },
  valoracion_final: "",
  observacion: "",
  decision: "",
});

export const mergeRivalEvaluation = (ev) => {
  const base = blankRivalEvaluation();
  if (!ev) return base;
  for (const a of ["tecnicos", "tacticos", "fisicos", "emocional"]) {
    if (ev[a]) base[a] = { score: ev[a].score ?? null, comment: ev[a].comment || "" };
  }
  base.valoracion_final = ev.valoracion_final || "";
  base.observacion = ev.observacion || "";
  base.decision = ev.decision || "";
  return base;
};
